import Invoice from './Invoice';

export default class InvoiceGroup {
    id?: number;
    groupNumber?: string;
    groupDate?: Date;
    clientId?: number;
    companyId?: number;
    stateId?: number;
    clientName?: string;
    clientAddress?: string;
    salutation?: string;
    signature?: string;
    signatureTitle?: string;
    landmanName?: string;
    city?: string;
    zipCode?: string;
    letterText?: string;
    isCoverLetter?: boolean;
    printPageNumber?: boolean;
    sectionOnInvoice?: boolean;
    bonusOption?: string;
    netAcres?: number;

    clientNumber?: string;
    invoices?: Invoice[];
}



// WEBPACK FOOTER //
// ./src/models/leasing/InvoiceGroup.ts